import Adal from '../adal/adal-request';
import { encodeData, REST_URL } from '../constants';
import * as types from './actionTypes';


import config from 'config'; // needed for appEnv

export function authUserAction() {
  return (dispatch) => {
    if (config.appEnv === 'dev') {
      // Immediate fake response in dev
      const mockData = {
        Id: 1212, // user ID of Kentta Tertta (admin)
        DisplayName: 'Admin User',
        userName: 'admin',
        profile: {
          roles: ['Admin']
        },
        IsAdmin: true,
        authenticated: true,
      };

      dispatch({ type: types.AUTH_USER_FULFILLED, payload: mockData });
      return Promise.resolve(mockData);
    }

    // Real ADAL call
    return Adal.adalRequest({ url: `${REST_URL}myInfo` })
      .then(data => {
        dispatch({ type: types.AUTH_USER_FULFILLED, payload: data });
        return data;
      })
      .catch(error => {
        dispatch({ type: types.AUTH_USER_REJECTED, payload: error });
        throw error;
      });
  };
}

export function setLocale(locale) {
  if (window.localStorage) {
    localStorage.setItem('locale', locale);
  }
    // best effort to send language back to server
  Adal.adalRequest({url: `${REST_URL}users/language?language=${locale}`, method: 'PUT' });
  return ({
    type: types.SET_LOCALE,
    payload: locale
  });
}


export function fetchSummaryInfo() {
  return ({
    type: types.FETCH_SUMMARY_INFO,
    payload: Adal.adalRequest({url: `${REST_URL}SummaryInfo`})
  });
}

export function fetchManagerAction(userId) {
  return ({
    type: types.FETCH_MANAGER,
    payload: Adal.adalRequest({url: `${REST_URL}users/parent/${userId}`})
  });
}

export function fetchUsersAction(pageIndex = 1, pageSize = 50, filter = {}) {
  filter = {pageIndex, pageSize, ...filter };
  return ({
    type: types.FETCH_USERS,
    payload: Adal.adalRequest({url: `${REST_URL}users?${encodeData(filter)}`})
  });
}

export function fetchUserToEdit(userId) {
  if (userId) {
    return ({
      type: types.FETCH_EDIT_USER,
      payload: Adal.adalRequest({url: `${REST_URL}users/${userId}`})
    });
  }
  return ({
    type: types.FETCH_EDIT_USER_FULFILLED,
    payload: {Manager: {}, CipGroup: {}}
  });

}

export function saveUser(userId, user) {
  if (userId) {
    return ({
      type: types.SAVE_USER,
      payload: Adal.adalRequest({url: `${REST_URL}users/${userId}`, method: 'PUT', data: JSON.stringify(user)})
    });
  }
  return ({
    type: types.SAVE_USER,
    payload: Adal.adalRequest({url: `${REST_URL}users`, method: 'POST', data: JSON.stringify(user) })
  });
}




// WEBPACK FOOTER //
// ./actions/userActions.js